/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
import type { Simulation } from "./Simulation";
import {
  SimulationFromJSON,
  SimulationFromJSONTyped,
  SimulationToJSON,
  SimulationToJSONTyped,
} from "./Simulation";

/**
 *
 * @export
 * @interface Template
 */
export interface Template {
  /**
   *
   */
  readonly url?: string;
  /**
   *
   */
  name: string;
  /**
   *
   */
  readonly id?: number;
  /**
   *
   */
  readonly created?: Date;
  /**
   *
   */
  readonly simulation?: Simulation;
}

/**
 * Check if a given object implements the Template interface.
 */
export function instanceOfTemplate(value: object): value is Template {
  if (!("name" in value) || value["name"] === undefined) return false;
  return true;
}

export function TemplateFromJSON(json: any): Template {
  return TemplateFromJSONTyped(json, false);
}

export function TemplateFromJSONTyped(json: any, ignoreDiscriminator: boolean): Template {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"] == null ? undefined : json["url"],
    name: json["name"],
    id: json["id"] == null ? undefined : json["id"],
    created: json["created"] == null ? undefined : parseDateTime(json["created"]),
    simulation: json["simulation"] == null ? undefined : SimulationFromJSON(json["simulation"]),
  };
}

export function TemplateToJSON(json: any): Template {
  return TemplateToJSONTyped(json, false);
}

export function TemplateToJSONTyped(
  value?: Omit<Template, "url" | "id" | "created" | "simulation"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    name: value["name"],
  };
}
